// Expose variables that are required in the views
window.router = require("history").createBrowserHistory();
